const deepMerge = require('./deep-merge');
const { debounce, throttle } = require('./debounce-throttle');
const Events = require('./events');

var DataTable = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = deepMerge({
        autoInit: true,
        sortReset: true
    }, opts || {});
    this.events = new Events();
    if (this.options.autoInit) {
        this.init();
    }
};

DataTable.prototype = {
    constructor: DataTable,
    $el: undefined,
    options: undefined,
    inited: undefined,
    events: undefined,
    init: function() {
        this.initTable(this.$el, this.options);
    },
    initTable: function($table, options) {
        var self = this;
        if (!($table instanceof jQuery)) {
            $table = $($table);
        }
        if ($table.bootstrapTable) {
            $table.bootstrapTable('destroy');
            self.inited = false;
        }
        options.onLoadSuccess = function() { self.handleLoadSuccess(); };
        $table.bootstrapTable(options);
    },
    handleLoadSuccess: function() {
        var self = this;
        if (!self.inited) {
            self.events.fire('loaded', { loadedAt: new Date() });
            self.inited = true;
        }
        self.loadSuccessEvents();
        self.events.fire('load-success', { loadedAt: new Date() });
    },
    loadSuccessEvents: function() {
        this.$el[0].querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new bootstrap.Tooltip(el));
    }
};

module.exports = DataTable;